import { config } from '../../config';
import { ChatService } from './live-chat.class';

export const liveChat: any = config.LC ? new ChatService() : null;
